<template>
  <div class="quik" ref="quikEl">
    <div class="quik-group">
      <router-link to="/apply-main" class="quik-item">
        <img src="@/assets/img/ico/i-quik-01.svg" alt="서비스 신청" />
        <h6>
          서비스
          <br />신청
        </h6>
      </router-link>
      <router-link to="/cs-faq" class="quik-item">
        <img src="@/assets/img/ico/i-quik-02.svg" alt="FAQ" />
        <h6>FAQ</h6>
      </router-link>
      <router-link to="/cs-qna" class="quik-item">
        <img src="@/assets/img/ico/i-quik-03.svg" alt="Q&amp;A" />
        <h6>Q&amp;A</h6>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "QuikButton",

  mounted() {
    const el = this.$refs.quikEl;
    if (!el) return;

    // 스크롤 이벤트 핸들러 정의
    this.onScroll = () => {
      if (window.scrollY > 200) {
        el.classList.add("active");
      } else {
        el.classList.remove("active");
      }
    };

    // 스크롤 이벤트 등록
    window.addEventListener("scroll", this.onScroll);
  },

  beforeUnmount() {
    // 이벤트 정리
    window.removeEventListener("scroll", this.onScroll);
  },
};
</script>